module.exports = __webpack_public_path__ + "media/images/restaurant/closed_ico-fefd43ad5dbc8293ea014c038e9f9ea6.png";